import { Box, Tab, Modal, Tabs } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import React, { useState } from "react";
import AddTherapyNote from "../Notes/AddTherapyNote";
import AddNonTherapyNote from "../Notes/AddNonTherapyNote";
import AddFamilyNote from "../Notes/AddFamilyNote";
import AddGroupNote from "../Notes/AddGroupNote";
import AddMedicalNote from "../Notes/AddMedicalNote";
import TopTitleNoteContainerMain from "../Notes/TopTitleNoteContainerMain";
import GroupNotesAll from "../containers/GroupNotesAll";
import HandoverNotesAll from "../containers/HandoverNotesAll";
import AddAftercareNote from "../Notes/AddAftercareNote";
import QuickNotesContainerAllMobile from "../containers/QuickNotesContainerAllMobile";
import NonTherapyNoteContainerAllMobile from "../containers/NonTherapyNoteContainerAllMobile";
import MedicalNotesAllMobile from "../containers/MedicalNotesAllMobile";
import FamilyNotesContainerAllMobile from "../containers/FamilyNotesContainerAllMobile";
import AftercareNotesContainerAllMobile from "../containers/AftercareNotesContainerAllMobile";
import AddHandoverNoteMobile from "../Notes/AddHandoverNoteMobile";
import AddEndOfShiftNoteMobile from "../Notes/AddEndOfShiftNoteMobile";
import EndOfShiftNotesContainerMobile from "../containers/EndOfShiftNotesContainerMobile";
import AddQuickNoteWithClientsMobile from "../Notes/AddQuickNoteWithClientsMobile";

function ClientNotesMainHospitalityMobile(props) {
  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 600,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleHandoverNote2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: "70%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleFamilyNote = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 800,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleGroupNote2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const dateToday = new Date();

  const [openQuickNote, setOpenQuickNote] = useState(false);
  const [openTherapyNote, setOpenTherapyNote] = useState(false);
  const [openNonTherapyNote, setOpenNonTherapyNote] = useState(false);
  const [openFamilyNote, setOpenFamilyNote] = useState(false);
  const [openGroupNote, setOpenGroupNote] = useState(false);
  const [openMedicalNote, setOpenMedicalNote] = useState(false);
  const [openHandoverNote, setOpenHandoverNote] = useState(false);
  const [openAftercareNote, setOpenAftercareNote] = useState(false);
  const [openEndOfShiftNote, setOpenEndOfShiftNote] = useState(false);

  const handleOpenQuickNote = () => setOpenQuickNote(true);
  const handleOpenFamilyNote = () => setOpenFamilyNote(true);
  const handleOpenGroupNote = () => setOpenGroupNote(true);
  const handleOpenMedicalNote = () => setOpenMedicalNote(true);
  const handleOpenHandoverNote = () => setOpenHandoverNote(true);
  const handleOpenEndOfShiftNote = () => setOpenEndOfShiftNote(true);

  const handleCloseTherapyNote = () => setOpenTherapyNote(false);
  const handleCloseNonTherapyNote = () => setOpenNonTherapyNote(false);
  const handleCloseQuickNote = () => setOpenQuickNote(false);
  const handleCloseFamilyNote = () => setOpenFamilyNote(false);
  const handleCloseGroupNote = () => setOpenGroupNote(false);
  const handleCloseMedicalNote = () => setOpenMedicalNote(false);
  const handleCloseHandoverNote = () => setOpenHandoverNote(false);
  const handleCloseAftercareNote = () => setOpenAftercareNote(false);
  const handleCloseEndOfShiftNote = () => setOpenEndOfShiftNote(false);

  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    // <div className="tab-container-white">
    //   <div className="tab-form-container">
    <div className="tab-form-container-for-notes-mobile">
      <Modal
        open={openQuickNote}
        onClose={handleCloseQuickNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <AddQuickNoteWithClientsMobile closemodal={handleCloseQuickNote} />
        </Box>
      </Modal>
      <Modal
        open={openTherapyNote}
        onClose={handleCloseTherapyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <AddTherapyNote
            dateTherapyNote={dateToday}
            closemodal={handleCloseTherapyNote}
          />
        </Box>
      </Modal>
      <Modal
        open={openNonTherapyNote}
        onClose={handleCloseNonTherapyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <AddNonTherapyNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseNonTherapyNote}
          />
        </Box>
      </Modal>

      <Modal
        open={openFamilyNote}
        onClose={handleCloseFamilyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleFamilyNote}>
          <AddFamilyNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseFamilyNote}
          />
        </Box>
      </Modal>
      <Modal
        open={openEndOfShiftNote}
        onClose={handleCloseEndOfShiftNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHandoverNote2}>
          <AddEndOfShiftNoteMobile
            closemodal={handleCloseEndOfShiftNote}
            // Autres props si nécessaire
          />
        </Box>
      </Modal>
      <Modal
        open={openGroupNote}
        onClose={handleCloseGroupNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleGroupNote2}>
          <AddGroupNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseGroupNote}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openMedicalNote}
        onClose={handleCloseMedicalNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <AddMedicalNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseMedicalNote}
          />
        </Box>
      </Modal>

      <Modal
        open={openHandoverNote}
        onClose={handleCloseHandoverNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHandoverNote2}>
          <AddHandoverNoteMobile
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseHandoverNote}
          />
        </Box>
      </Modal>

      <Modal
        open={openAftercareNote}
        onClose={handleCloseAftercareNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <AddAftercareNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseAftercareNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openEndOfShiftNote}
        onClose={handleCloseEndOfShiftNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHandoverNote2}>
          <AddEndOfShiftNoteMobile
            closemodal={handleCloseEndOfShiftNote}
            // Autres props si nécessaire
          />
        </Box>
      </Modal>

      <Box sx={{ padding: "16px", width: "100%" }}>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divier",
              width: "auto",
            }}
          >
            <Tabs
              // sx={{ width: "100%" }}
              variant="scrollable"
              allowScrollButtonsMobile
              onChange={handleChange}
              aria-label="simple tabs example"
              value={value}
            >
              <Tab label="Quick notes" value="1" />
              <Tab label="Handover notes" value="2" />
              <Tab label="1 to 1 support staff notes" value="3" />
              <Tab label="Medical notes" value="4" />
              <Tab label="Group notes" value="5" />
              <Tab label="Family / significant other notes" value="6" />
              <Tab label="Support Aftercare notes" value="7" />
              <Tab label="End of shift notes" value="8" />
            </Tabs>
          </Box>
          <TabPanel value="1">
            <TopTitleNoteContainerMain
              showButton={true}
              title="Add quick note"
              handleOpen={handleOpenQuickNote}
            />
            <QuickNotesContainerAllMobile
              clientId={props.clientId}
              {...props}
            />
          </TabPanel>
          <TabPanel value="2">
            <TopTitleNoteContainerMain
              showButton={true}
              title="Add handover note"
              handleOpen={handleOpenHandoverNote}
            />
            <HandoverNotesAll />
          </TabPanel>
          <TabPanel value="3">
            {/* <TopTitleNoteContainerMain
              title="Add 1 to 1 support staff note"
              handleOpen={handleOpenHandoverNote}
            /> */}
            <NonTherapyNoteContainerAllMobile />
          </TabPanel>
          <TabPanel value="4">
            <TopTitleNoteContainerMain
              title="Add medical note"
              handleOpen={handleOpenMedicalNote}
            />
            <MedicalNotesAllMobile clientId={props.clientId} {...props} />
          </TabPanel>
          <TabPanel value="5">
            <TopTitleNoteContainerMain
              showButton={true}
              title="Add group note"
              handleOpen={handleOpenGroupNote}
            />
            <GroupNotesAll />
          </TabPanel>
          <TabPanel value="6">
            <TopTitleNoteContainerMain
              title="Add family/significant other note"
              handleOpen={handleOpenFamilyNote}
            />
            <FamilyNotesContainerAllMobile
              clientId={props.clientId}
              {...props}
            />
          </TabPanel>

          <TabPanel value="7">
            {/* <TopTitleNoteContainerMain
              title="Add aftercare note"
              handleOpen={handleOpenAftercareNote}
            /> */}
            <AftercareNotesContainerAllMobile
              clientId={props.clientId}
              {...props}
            />
          </TabPanel>
          <TabPanel value="8">
            <TopTitleNoteContainerMain
              showButton={true}
              title="Add End of shift note"
              handleOpen={handleOpenEndOfShiftNote}
            />
            <EndOfShiftNotesContainerMobile
              clientId={props.clientId}
              {...props}
            />
          </TabPanel>
        </TabContext>
      </Box>
      {/* </Container> */}
    </div>
    // </div>
  );
}

export default ClientNotesMainHospitalityMobile;
